<jhi-data-filter *ngIf="filtersOptions" [filters]="filters" [options]="filtersOptions" (filtersChange)="filtersCurrentChanged($event)"></jhi-data-filter>

<jhi-bary-table-manager-action-button
  [tableOptions]="tableOptions"
  (newEvent)="createNew($event)"
  (newAndRedirectEvent)="createAndRedirect($event)"
  [items]="data"
></jhi-bary-table-manager-action-button>

<ng-container *ngIf="loaded">
  <ng-content></ng-content>
</ng-container>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)"></ngx-spinner>

<div class="row justify-content-center" *ngIf="pagination.page > 1 || (data && data.length && data.length >= this.ITEMS_PER_PAGE)">
  <ngb-pagination
    [collectionSize]="totalItems"
    [(page)]="pagination.page"
    [pageSize]="ITEMS_PER_PAGE"
    [maxSize]="5"
    [rotate]="true"
    [boundaryLinks]="true"
    (pageChange)="loadPage(pagination.page)"
  ></ngb-pagination>
</div>
